import * as React from "react";

function SvgProsperStack(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M125.578 59.985l-65.76-13.99c-.472-.135-1.013-.135-1.554-.135-1.757 0-3.446.608-4.595 1.69L25.824 73.908c-1.69 1.554-1.96 3.852-.744 5.677 1.082 1.622 3.11 2.568 5.34 2.568.338 0 .675 0 .946-.068l93.672-12.368c2.838-.405 5.001-2.365 5.136-4.663.135-2.366-1.757-4.46-4.596-5.069zM4.535 105.875l65.827 13.99c.473.135 1.014.135 1.555.135 1.757 0 3.446-.608 4.595-1.69l27.845-26.358c1.69-1.554 1.96-3.852.743-5.677-1.081-1.622-3.108-2.568-5.339-2.568-.338 0-.676 0-.946.068L5.143 96.143c-2.838.405-5.001 2.365-5.136 4.663-.135 2.366 1.757 4.528 4.528 5.069z"
        fill="#2F75FF"
      />
      <path
        d="M73.336.578L11.902 27.95a8.664 8.664 0 00-1.352.744c-1.42 1.013-2.433 2.5-2.704 4.122L.75 70.528c-.405 2.298.676 4.258 2.771 5.001 1.825.676 4.055.203 5.812-1.08.27-.204.541-.406.744-.61l68.53-65.015c2.095-1.96 2.636-4.799 1.352-6.826C78.742.038 75.904-.57 73.336.578z"
        fill="#2FAAFF"
      />
    </svg>
  );
}

export default React.forwardRef(SvgProsperStack);
